export default __webpack_public_path__ + "b84b61d34ff17a8e29725ecd5ec0e0a9.otf";